import React, { useEffect, useState } from 'react';
import Reveal from './ui/Reveal';
import ShinyText from './reactbits/ShinyText/ShinyText';
import SpotlightCard from './reactbits/SpotlightCard/SpotlightCard';

const loadSwiper = async () => {
  const [{ Swiper, SwiperSlide }, { Autoplay }] = await Promise.all([
    import('swiper/react'),
    import('swiper/modules'),
  ]);
  return { Swiper, SwiperSlide, Autoplay };
};

const teamMembers = [
  {
    name: 'Usman Zahid',
    title: 'Company Director',
    img: '/assets/img/team/Usman%20Zahid.png',
    delay: '200ms',
    socials: [{ href: 'https://www.linkedin.com/company/nalexus-technologies/', iconClass: 'bx bxl-linkedin' }],
  },
  {
    name: 'Abdul Basit Malik',
    title: 'Company Director',
    img: '/assets/img/team/Abdul%20Basit.png',
    delay: '300ms',
    socials: [{ href: 'https://www.linkedin.com/company/nalexus-technologies/', iconClass: 'bx bxl-linkedin' }],
  },
  {
    name: 'Zainab Touseef',
    title: 'Managment Director',
    img: '/assets/img/team/Zainab%20Touseef.png',
    delay: '400ms',
    socials: [{ href: 'https://www.linkedin.com/company/nalexus-technologies/', iconClass: 'bx bxl-linkedin' }],
  },
  {
    name: 'Affan Azeem',
    title: 'Business Growth Manager',
    img: '/assets/img/team/Affan%20Azeem.png',
    delay: '500ms',
    socials: [{ href: 'https://www.linkedin.com/company/nalexus-technologies/', iconClass: 'bx bxl-linkedin' }],
  },
  {
    name: 'Esbah Khan',
    title: 'Marketing Manager',
    img: '/assets/img/team/Esbah%20Khan.png',
    delay: '600ms',
    socials: [{ href: 'https://www.linkedin.com/company/nalexus-technologies/', iconClass: 'bx bxl-linkedin' }],
  },
  {
    name: 'Raamiz Khan',
    title: 'Business Growth Manager',
    img: '/assets/img/team/Raamiz%20Khan.png',
    delay: '700ms',
    socials: [{ href: 'https://www.linkedin.com/company/nalexus-technologies/', iconClass: 'bx bxl-linkedin' }],
  },
  {
    name: 'Rohma Naveed',
    title: 'Social Media Manager',
    img: '/assets/img/team/Rohma%20Naveed.png',
    delay: '800ms',
    socials: [{ href: 'https://www.linkedin.com/company/nalexus-technologies/', iconClass: 'bx bxl-linkedin' }],
  },
];

const AboutTeam = () => {
  const [{ Swiper, SwiperSlide, Autoplay }, setSwiper] = useState({});

  useEffect(() => {
    const id = 'swiper-css';
    if (!document.getElementById(id)) {
      const link = document.createElement('link');
      link.id = id;
      link.rel = 'stylesheet';
      link.href = '/assets/css/swiper-bundle.min.css';
      document.head.appendChild(link);
    }
    loadSwiper().then(setSwiper);
  }, []);

  return (
    <div className="home3-team-area sec-mar">
      <div className="container">
        {/* Section Heading */}
        <Reveal
          className="row mb-55 wow animate fadeInUp"
          delay={0.1}
        >
          <div className="col-lg-12 d-flex justify-content-center">
            <div className="section-title-3 text-center">
              <h2>
                <ShinyText
                  text="Meet The Team"
                  className="nalexus-heading-shine"
                  color="#f1ede3"
                  shineColor="#ffd369"
                  speed={2.6}
                />
              </h2>
              <p>
                A cross-functional leadership and delivery team focused on dependable execution, clear communication, and long-term client value.
              </p>
            </div>
          </div>
        </Reveal>

        {Swiper && SwiperSlide && Autoplay ? (
          <Swiper
            className="about-team-swiper"
            modules={[Autoplay]}
            loop
            speed={900}
            autoplay={{ delay: 2600, disableOnInteraction: false, pauseOnMouseEnter: true }}
            spaceBetween={24}
            slidesPerView={1}
            breakpoints={{
              576: { slidesPerView: 2 },
              992: { slidesPerView: 4 },
            }}
          >
            {teamMembers.map((member, idx) => (
              <SwiperSlide key={idx}>
                <div className="experts h-100">
                  <SpotlightCard className="experts-card magnetic-item nalexus-spotlight h-100" spotlightColor="rgba(223, 169, 37, 0.3)">
                    <div className="experts-img">
                      <img
                        className="img-fluid"
                        src={member.img}
                        alt={member.name}
                        style={{ aspectRatio: '1 / 1', objectFit: 'cover' }}
                      />
                      <div className="expert-social">
                        <ul>
                          {member.socials.map((social, i) => (
                            <li key={i}>
                              <a href={social.href} target="_blank" rel="noreferrer">
                                <i className={social.iconClass}></i>
                              </a>
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>
                    <div className="experts-content">
                      <h4>{member.name}</h4>
                      <span>{member.title}</span>
                    </div>
                  </SpotlightCard>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        ) : null}
      </div>
    </div>
  );
};

export default AboutTeam;






